import util from "@/common/util";
import { iWorkspace, iPrice, iInterface, iUser } from "@/services";

const state = {
  info: {
    projectId: 0,
    taskId: 0,
    interfaceId: 0,
    workType: "",
    manualUrl: "",
    isProjectCompleted: false,
    isPaymentCalculated: false,
    progressInfo: {
      completeCount: 0,
      totalCount: 0,
      rate: 0,
    },
  },

  classes: [],
  taskItems: [],
  objects: [],
  taskItem: {
    id: 0,
    file: null,
    fileName: "",
    filePath: "",
    fileExt: "",
    workers: null,
    operatedDate: "",
    inspectedDate: "",
    operateExpiredDate: "",
    inspectExpiredDate: "",
    minWorkTime: "",
    setNum: null,
    itemStatus: "",
    workable: false,
    orgWorkable: false,
    attrOnly: false,
  },
  taskItemsOption: {
    totalCount: 0,
    keyword: "",
    statuses: [],
    operatorIds: [],
    page: 1,
    limit: 20,
    taskItemIdList: [],
  },
  page: {
    currentPage: 0,
    totalPage: 0,
    totalCount: 0,
  },
  canvasOption: {
    comment: false,
    commentInput: false,
    creating: false,
    editable: false,
    doCopyNext: false,
    brightness: 50,
    contrast: 50,
    textSize: 10,
    lineSize: 1,
    pointSize: 4,
    crossline: false,
    gridline: 0,
    opacity: 25,
    gridlineSave: 10,
    iconPosition: [],
    iconVisible: false,
    imgSize: {},
    controlOpen: false,
  },
  // -------------
  wsData: {
    class: {
      id: "",
      name: "",
      type: "",
      color: "",
      label: "",
    },
  },
  aroundItemExists: {
    previous: false,
    next: false,
  },
  selectedObjects: [],
  selectedLine: [-1, -1],
  groupPointCreatingIdx: 0,
  loading: true,
  saving: false,
  pageLoading: false,
  workloadSatisfied: false,
  minTimeFinished: false,
  panelOpts: {
    left: {
      open: true,
      width: 300,
    },
    right: {
      open: true,
      width: 360,
    },
  },
  commentMode: {
    comments: [],
    isAllSolved: true,
    imageId: "",
    selectedImage: {},
    selectedId: "",
  },
  modal: {
    delayItem: false,
  },
  isDelayChecked: false,
  beforeTaskItem: {
    id: null,
    itemStatus: null,
  },
  attrPointer: -1,
  attributeTab: "OBJECT",
  priceChange: false,
  priceModal: false,
};

const mutations = {
  SET_WORKABLE(state, data) {
    state.taskItem.workable = data;
    state.saving = !data;
  },
  SET_ATTR_ONLY_MODE(state, data) {
    state.taskItem.attrOnly = data;
  },
  SET_TASKITEM_ID_STATUS: (state, data) => {
    state.beforeTaskItem.id = state.taskItem.id;
    state.beforeTaskItem.itemStatus = state.taskItem.itemStatus;
    state.taskItem.id = data.itemId;
    state.taskItem.itemStatus = data.status;
  },
  SET_ROLLBACK_TASKITEM_ID_STATUS: (state) => {
    [state.beforeTaskItem.id, state.beforeTaskItem.itemStatus] = [
      state.taskItem.id,
      state.taskItem.itemStatus,
    ];
  },
  INIT_WORKSPACE: (state) => {
    state.info = {
      projectId: 0,
      taskId: 0,
      interfaceId: 0,
      workType: "",
      manualUrl: "",
      isProjectCompleted: false,
      isPaymentCalculated: false,
      progressInfo: {
        completeCount: 0,
        totalCount: 0,
        rate: 0,
      },
    };
    state.classes = [];
    state.taskItems = [];
    state.objects = [];
    state.taskItem = {
      id: 0,
      file: null,
      fileName: "",
      filePath: "",
      fileExt: "",
      workers: null,
      operatedDate: "",
      inspectedDate: "",
      operateExpiredDate: "",
      inspectExpiredDate: "",
      minWorkTime: "",
      setNum: null,
      itemStatus: "",
      workable: false,
      orgWorkable: false,
      attrOnly: false,
    };
    state.taskItemsOption = {
      totalCount: 0,
      keyword: "",
      statuses: [],
      operatorIds: [],
      page: 1,
      limit: 20,
      taskItemIdList: [],
    };
    state.page = {
      currentPage: 0,
      totalPage: 0,
      totalCount: 0,
    };
    state.canvasOption = {
      comment: false,
      commentInput: false,
      creating: false,
      editable: false,
      doCopyNext: false,
      brightness: 50,
      contrast: 50,
      textSize: 10,
      lineSize: 1,
      pointSize: 4,
      crossline: false,
      gridline: 0,
      opacity: 25,
      gridlineSave: 10,
      iconPosition: [],
      iconVisible: false,
      imgSize: {},
      controlOpen: false,
    };
    state.wsData = {
      class: {
        id: "",
        name: "",
        type: "",
        color: "",
        label: "",
      },
    };
    state.aroundItemExists = {
      previous: false,
      next: false,
    };
    state.selectedObjects = [];
    state.groupPointCreatingIdx = 0;
    state.loading = true;
    state.saving = false;
    state.pageLoading = false;
    state.modal = {
      delayItem: false,
    };
    state.isDelayChecked = false;
    state.attrPointer = -1;
    state.priceChange = false;
    state.priceModal = false;
  },
  SET_WORKSPACE_INFO: (state, data) => {
    state.info.projectId = data.projectId;
    state.info.taskId = data.taskId;
    state.info.interfaceId = data.interfaceId;
    state.info.manualUrl = data.manualUrl;
    state.info.workType = data.workType;
  },
  SET_CLASSES: (state, data) => {
    const OPTION_STATUS = {
      label: true,
      count: 0,
      visible: true,
      selected: false,
      open: false,
      error: false,
    };

    data.map((cls) => {
      cls.currentStatus = structuredClone(OPTION_STATUS);
      const children = [];
      cls.childrens.forEach((child) => {
        const copyCnt = child.endIndex - child.startIndex + 1;
        for (let i = 0; i < copyCnt; i++) {
          const tmp = structuredClone(child);
          tmp.attributes = cls.attributes;
          tmp.currentStatus = OPTION_STATUS;
          children.push(structuredClone(tmp));
        }
      });
      cls.childrens = children;
    });

    state.classes = data;
  },
  SET_TASKITEMS: (state, data) => {
    const items = data.items.map((item) => {
      return {
        id: item.itemId,
        name: item.fileName,
        status: item.itemStatus,
        setNum: item.setNum,
      };
    });

    state.taskItems = items;
  },
  // 툴바 컨트롤러 오픈 유무확인
  SET_CONTROL_OPEN: (state, data) => {
    state.canvasOption.controlOpen = data;
  },
  SET_WORKSPACE_PAGE_INFO: (state, data) => {
    state.page.currentPage = data.currentPage;
    state.page.totalPage = data.totalPage;
    state.page.totalCount = data.totalCount;
    state.taskItemsOption.page = data.currentPage;
  },
  SET_TASKITEM_OPTION_PAGE: (state, data) => {
    state.taskItemsOption.page = data.page;
  },
  SET_TASKITEM_INFO: (state, data) => {
    state.taskItem.fileName = data.file.name;
    state.taskItem.filePath = data.file.url;
    state.taskItem.fileExt = data.file.name.split(".").pop();
    state.taskItem.workers = data.workers;
    state.taskItem.operatedDate = data.timeWindow.operationStartedAt;
    state.taskItem.inspectedDate = data.timeWindow.inspectionStartedAt;
    state.taskItem.operateExpiredDate = data.timeWindow.operationExpiredAt;
    state.taskItem.inspectExpiredDate = data.timeWindow.inspectionExpiredAt;
    state.taskItem.minWorkTime = data.meta.minWorkTimeSec;
    state.taskItem.itemStatus = data.status;
    state.taskItem.setNum = data.meta.setNum;

    state.taskItem.orgWorkable = data.meta.workable;
    state.taskItem.workable = state.canvasOption.comment
      ? false
      : data.meta.workable;

    state.info.isProjectCompleted = data.meta.projectCompleted;
    state.info.isPaymentCalculated = data.paymentCalculated;
  },
  SET_OBJECTS: (state, _objects) => {
    const OPTION_STATUS = {
      selected: false,
      open: false,
      visible: true,
      error: false,
    };

    _objects = _objects || [];

    const objects = util.importTaskResult(_objects, state.classes);
    objects.map((obj) => {
      obj.currentStatus = structuredClone(OPTION_STATUS);

      const errors = util.checkObjectHasError(obj);
      const hasError = errors.attribute || errors.option || errors.side;
      obj.currentStatus.error = hasError;

      obj.childrens.forEach((child) => {
        child.currentStatus = structuredClone(OPTION_STATUS);
      });

      if (obj.type === "GROUP_POINT") {
        obj = util.validateGroupPoint(obj);
      }
    });

    state.objects = objects;
  },
  SET_CURRENT_TASKITEM_STATUS: (state, data) => {
    state.taskItem.itemStatus = data.status;
    const target = state.taskItems.find(
      (item) => item.id === state.taskItem.id
    );

    if (!target) {
      return;
    }

    target.status = data.status;
  },
  SET_WORKSPACE_PROGRESS: (state, data) => {
    state.info.progressInfo = data.progressInfo;
  },
  // -----------------------------------------------------------------
  UPDATE_TASKITEM_ID: (state, data) => {
    state.taskItem.id = data.id;
  },
  UPDATE_TASKITEM_FILE: (state, data) => {
    state.taskItem.file = data.file;
  },
  UPDATE_AROUND_TASKITEM_EXISTS: (state, data) => {
    const previous = data.currentTaskItemId !== data.previousTaskItemId;
    state.aroundItemExists.previous = previous;
    const next = data.currentTaskItemId !== data.nextTaskItemId;
    state.aroundItemExists.next = next;
  },
  SET_TASKITEM_FILTER: (state, data) => {
    state.taskItemsOption.statuses = data.statuses;
  },
  SET_TASKITEM_WORKER_FILTER: (state, data) => {
    state.taskItemsOption.operatorIds = data.operatorIds;
  },
  SET_TASKITEM_SEARCH: (state, data) => {
    state.taskItemsOption.keyword = data.keyword;
  },
  SET_CLASS_SELECTED: (state, data) => {
    state.classes.map((cls) => (cls.currentStatus.selected = false));
    const cls = state.classes.find((cls) => cls.id === data.id);
    cls.currentStatus.selected = data.selected;

    if (!data.selected) {
      state.wsData.class.id = "";
      state.wsData.class.name = "";
      state.wsData.class.type = "";
      state.wsData.class.color = "";
      state.wsData.class.label = "";
      state.wsData.class.options = [];
      state.wsData.class.lineAttributes = [];
      state.wsData.class.lineOptions = {};
      return;
    }
    state.wsData.class.id = cls.id;
    state.wsData.class.name = cls.name;
    state.wsData.class.type = cls.type;
    state.wsData.class.color = cls.color;
    state.wsData.class.label = cls.currentStatus.label;
    state.wsData.class.options = cls.options;
    state.wsData.class.lineAttributes = cls.lineAttribute?.attributes || [];
    state.wsData.class.lineOptions = cls.lineAttribute?.option || {};
  },
  SET_CLASS_VISIBLE: (state, data) => {
    const classes = state.classes;
    const cls = classes.find((cls) => cls.id === data.id);
    cls.currentStatus.visible = data.visible;
  },
  SET_CLASS_LABEL: (state, data) => {
    const cls = state.classes.find((cls) => cls.id === data.id);
    cls.currentStatus.label = data.label;

    if (cls.id === state.wsData.class.id) {
      state.wsData.class.label = cls.currentStatus.label;
    }
  },
  //---
  SET_OPACITY: (state, data) => {
    state.canvasOption.opacity = data;
  },
  SET_CONTRAST: (state, data) => {
    state.canvasOption.contrast = data;
  },
  SET_BRIGHTNESS: (state, data) => {
    state.canvasOption.brightness = data;
  },
  SET_TEXTSIZE: (state, data) => {
    state.canvasOption.textSize = data;
  },
  SET_LINESIZE: (state, data) => {
    state.canvasOption.lineSize = data;
  },
  SET_POINTSIZE: (state, data) => {
    state.canvasOption.pointSize = data;
  },
  SET_CROSSLINE: (state, data) => {
    state.canvasOption.crossline = data;
  },
  SET_GRIDLINE: (state, data) => {
    state.canvasOption.gridlineSave = state.canvasOption.gridline;
    state.canvasOption.gridline = data;
  },
  SET_COMMENT_MODE: (state, data) => {
    state.canvasOption.comment = data.comment;
    // 코멘트모드일 때
    if (state.canvasOption.comment) {
      state.taskItem.workable = false;
    } else {
      state.taskItem.workable = state.taskItem.orgWorkable;
    }

    if (!state.panelOpts.right.open) {
      return;
    }

    if (data.comment && state.panelOpts.right.width < 660) {
      state.panelOpts.right.width += 300;
      return;
    } else if (data.comment && state.panelOpts.right.width >= 660) {
      state.panelOpts.right.width = 660;
      return;
    } else {
      state.panelOpts.right.width -= 300;
    }
  },
  SET_SELECT_COMMENT_ID: (state, data) => {
    state.commentMode.selectedId = data.id;
  },
  SET_COMMENT: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    const object = all.find((obj) => obj.id === data.id);
    if (!object) {
      return;
    }
    object.currentStatus.selected = data.selected;
    if (data.selected && object.parentId) {
      const parent = all.find((obj) => obj.id === object.parentId);
      parent.currentStatus.open = true;
    }
    const selects = state.objects.filter((obj) => obj.currentStatus.selected);
    state.selectedObjects = selects;
    // 해당 객체에 대한 데이터가 있는 지 확인 후,
    // 데이터가 없다면 코멘트 생성
    const checkComment = state.commentMode.comments.filter(
      (item) => item.objectId === object.id
    ).length;
    if (
      checkComment !== 0 ||
      state.selectedObjects.length === 0 ||
      state.info.workType === "OPERATOR"
    ) {
      state.canvasOption.commentInput = false;
    } else {
      // 코멘트가 생성 될 때.
      state.canvasOption.commentInput = true;
    }
    state.commentMode.imageId = "";
  },

  SET_IMAGE_COMMENT: (state, data) => {
    // 이미지를 선택하고 코멘트 리스트에서 이미지가 있는지 확인
    const checkComment = state.commentMode.comments.filter(
      (item) => item.objectId === data.id
    );
    // 코멘트에 이미지가 있거나, 작업자가 OPERATOR일 경우 코멘트박스는 나오지 않게
    if (checkComment.length !== 0 || state.info.workType === "OPERATOR") {
      state.canvasOption.commentInput = false;
    } else {
      // 이미지를 선택했을 때 임시로 selectedObjects 인덱스에 정보를 저장.
      // 코멘트 카드에서 정보를 읽게함.
      const imgObj = {
        id: data.id,
        name: "이미지",
        type: "IMAGE",
        selected: data.selected,
      };
      state.selectedObjects = [imgObj, ...state.selectedObjects];
      state.canvasOption.commentInput = true;
    }
    state.commentMode.imageId = data.id;
  },
  SET_IMAGE_RESET: (state) => {
    state.commentMode.imageId = "";
    state.canvasOption.commentInput = false;
  },
  SET_COMMENT_INPUT: (state, data) => {
    state.canvasOption.commentInput = data.commentInput;
  },
  SET_COMMENTS: (state, data) => {
    state.commentMode.comments = data.comments;
    state.commentMode.isAllSolved = data.isAllSolved;
  },
  SET_ICON_DISABLE: (state, data) => {
    if (!data.includes("IMAGE")) {
      const target = document.querySelector(
        `[data-id="${data}"] .comment-icon image`
      );
      target.setAttribute("width", 0), target.setAttribute("height", 0);
    } else {
      const target = document.querySelector(`[data-id="${data}"] image`);
      target.setAttribute("width", 0), target.setAttribute("height", 0);
    }
  },
  SET_SELECTED_LINE: (state, data) => {
    state.selectedLine = data;
  },
  // ------------------------------------------------------------------
  SET_GROUP_POINT_POINTER: (state, data) => {
    state.groupPointCreatingIdx = data.idx;
  },
  ADD_OBJECT: (state, data) => {
    const exists = state.objects.map((obj) => obj.id).indexOf(data.object.id);
    if (exists !== -1) {
      return;
    }
    state.objects.push(data.object);
  },
  ADD_OBJECTS: (state, data) => {
    data.objects.forEach((object) => {
      const exists = state.objects.map((obj) => obj.id).indexOf(object.id);
      if (exists !== -1) {
        return;
      }
      state.objects.push(object);
    });
  },
  REMOVE_OBJECT: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    const target = all.find((obj) => obj.id === data.id);

    const targetIds = [target.parentId, data.id];
    state.objects = state.objects.filter((obj) => !targetIds.includes(obj.id));
  },
  UPDATE_OBJECT_CLASS: (state, data) => {
    const { object: targetObj, class: targetCls } = data;
    targetCls.classId = targetCls.id;
    delete targetCls.id;

    state.objects = state.objects.map((obj) => {
      if (obj.id !== targetObj.id) {
        return obj;
      }

      if (targetCls.lineAttribute) {
        obj.lineOptions = targetCls.lineAttribute.option;
      }

      const orgCls = state.classes.find((cls) => cls.id === obj.classId);

      let attributes = structuredClone(targetCls.attributes);

      // orgCls의 attributes를 Map으로 변환하여 빠른 검색이 가능하게 함
      const orgAttrsMap = new Map(
        orgCls.attributes.map((attr, idx) => [
          JSON.stringify(attr),
          { attr, idx },
        ])
      );

      // 한 번의 순회로 매칭되는 attributes 찾기
      targetCls.attributes.forEach((targetAttr, tidx) => {
        const key = JSON.stringify(targetAttr);
        const match = orgAttrsMap.get(key);
        if (match) {
          attributes[tidx] = obj.attributes[match.idx];
        }
      });

      return { ...obj, ...targetCls, attributes };
    });
  },
  UPDATE_OBJECT_POINT: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    const target = all.find((obj) => obj.id === data.id);
    if (!target) {
      return;
    }
    target.points = data.points;
  },
  SET_OBJECT_SELECTED: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    const object = all.find((obj) => obj.id === data.id);
    if (!object) {
      return;
    }
    object.currentStatus.selected = data.selected;

    if (data.selected && object.parentId) {
      const parent = all.find((obj) => obj.id === object.parentId);
      parent.currentStatus.open = true;
    }

    const selects = state.objects.filter((obj) => obj.currentStatus.selected);
    state.selectedObjects = selects;
  },
  REMOVE_ALL_OBJECT: (state) => {
    state.objects = [];
  },
  SET_ALL_OBJECT_SELECTED: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    all.map((obj) => {
      obj.currentStatus.selected = data.selected;
    });

    const selects = state.objects.filter((obj) => obj.currentStatus.selected);
    state.selectedObjects = selects;
  },
  SET_OBJECT_VISIBLE: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    const object = all.find((obj) => obj.id === data.id);
    if (!object) {
      return;
    }
    object.currentStatus.visible = data.visible;
  },
  SET_ALL_OBJECT_VISIBLE: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    all.map((obj) => {
      obj.currentStatus.visible = data.visible;
    });
  },
  SET_OBJECT_OPEN: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    const object = all.find((obj) => obj.id === data.id);
    if (!object) {
      return;
    }
    object.currentStatus.open = data.open;
  },
  SET_OBJECT_Z_ORDER: (state, { objects }) => {
    objects.forEach((object) => {
      const id = object.id;
      const zOrder = object.zOrder;
      const find = state.objects.find((obj) => obj.id === id);
      find.zOrder = zOrder;
      find.order = zOrder;
    });
  },
  SET_DO_COPY_NEXT: (state, data) => {
    state.canvasOption.doCopyNext = data.doCopyNext;
  },
  SET_WORKSPACE_LOADING: (state, data) => {
    if (state.loading === data.loading) return;
    state.loading = data.loading;
  },
  SET_WORKSPACE_SAVING: (state, data) => {
    state.saving = data.saving;
  },
  SET_WORKSPACE_PAGE_LOADING: (state, data) => {
    state.pageLoading = data.pageLoading;
  },
  SET_IS_WORKLOAD_SATISFIED: (state, data) => {
    state.workloadSatisfied = data.workloadSatisfied;
  },
  SET_PRICE_MODAL: (state, data) => {
    state.priceModal = data.priceModal;
  },
  SET_IS_MIN_TIME_FINISHED: (state, data) => {
    state.minTimeFinished = data;
  },
  SET_LEFT_PANEL_OPTS: (state, data) => {
    state.panelOpts.left.open = data.open;
    state.panelOpts.left.width = data.width;
  },
  SET_RIGHT_PANEL_OPTS: (state, data) => {
    state.panelOpts.right.open = data.open;
    state.panelOpts.right.width = data.width;
  },
  SET_IMG_SIZE: (state, data) => {
    state.canvasOption.imgSize = data;
  },
  OPEN_DELAY_ITEM_MODAL: (state, data) => {
    state.modal.delayItem = data.open;
  },
  IS_DELAY_MODAL_ONCE_OPENED: (state, data) => {
    state.isDelayChecked = data;
  },
  SET_ATTRIBUTE_POINTER: (state, data) => {
    state.attrPointer = data;
  },
  SET_ATTRIBUTE_TAB: (state, data) => {
    state.attributeTab = data;
  },
  SET_EDITABLE: (state, data) => {
    state.canvasOption.editable = data;
  },
};

const actions = {
  async getTodoTaskItemId({ state, commit }, payload = {}) {
    payload.workType = payload.workType
      ? payload.workType
      : state.info.workType;

    const res = await iWorkspace.getTodoTaskItemId({
      ...getTaskItemsParams(),
      ...payload,
    });
    const code = res?.data.code;
    const data = res?.data;

    if (code !== "") {
      return data;
    }

    if (data.itemId) {
      commit("SET_TASKITEM_ID_STATUS", data);
    }

    return data;
  },
  async getNextTaskItemId({ commit }, payload = {}) {
    const res = await iWorkspace.getNextTaskItemId({
      ...getTaskItemsParams(),
      ...payload,
    });
    const code = res?.data.code;
    const data = res?.data;

    if (code !== "") {
      return data;
    }

    if (data.itemId) {
      commit("SET_TASKITEM_ID_STATUS", data);
    }

    return data;
  },
  async getPrevTaskItemId({ commit }, payload = {}) {
    const res = await iWorkspace.getPrevTaskItemId({
      ...getTaskItemsParams(),
      ...payload,
    });
    const code = res?.data.code;
    const data = res?.data;

    if (code !== "") {
      return data;
    }

    if (data.itemId) {
      commit("SET_TASKITEM_ID_STATUS", data);
    }

    return data;
  },
  async assignTaskItem({ commit }, payload) {
    const res = await iWorkspace.assignTaskItem(payload);
    const code = res?.data.code;
    const data = res?.data;

    if (code === "W0007") {
      commit("SET_IS_WORKLOAD_SATISFIED", { workloadSatisfied: true });
    }

    if (code === "W0009") {
      commit("SET_PRICE_MODAL", { priceModal: true });
    }

    if (code !== "") {
      return data;
    }

    if (data.itemId) {
      commit("SET_TASKITEM_ID_STATUS ", data);
    }

    return data;
  },
  async enterWorkspace({ commit, dispatch }, payload) {
    const res = await iWorkspace.getWorkspaceInfo({
      workType: payload.workType,
      taskId: payload.taskId,
    });
    let code = res?.data.code;
    if (code !== "") {
      return code;
    }

    commit("SET_WORKSPACE_INFO", res.data.payload);

    dispatch("setProgress");
    await dispatch("setClasses");
    code = await dispatch("setTaskItemById", {
      taskItemId: payload.taskItemId,
    });

    return code;
  },
  async setWorkspaceInfo({ commit }, payload) {
    const res = await iWorkspace.getWorkspaceInfo(payload);
    const code = res?.data.code;
    if (code !== "") {
      return code;
    }

    commit("SET_WORKSPACE_INFO", res.data.payload);
    return code;
  },
  async setProgress({ state, commit }) {
    const profileRes = await iUser.getProfile();

    if (profileRes.data.payload === "nstudio") return;

    const payload = {
      taskId: state.info.taskId,
      taskItemId: state.taskItem.id,
      workType: state.info.workType,
    };
    const res = await iWorkspace.getWorkspaceProgressInfo(payload);

    const data = { progressInfo: res.data.payload };
    commit("SET_WORKSPACE_PROGRESS", data);

    return res.data.code;
  },
  async setClasses({ state, commit }) {
    const id = state.info.interfaceId;
    const res = await iInterface.getInterfaceDetail({ id });
    const code = res?.data.code;

    if (code !== "") {
      return code;
    }

    // 서버 형식이 바뀌어서 이에 임시로 대응
    const classData = res.data.payload.classData.map((cls) => {
      const ret = { ...cls, ...cls.data };
      ret.childrens = ret.children || [];
      delete ret.children;
      delete ret.data;
      return ret;
    });

    commit("SET_CLASSES", classData);
    return code;
  },
  async setTaskItems({ state, commit, dispatch }, fixPage = -1) {
    await dispatch("setWorkspacePage", fixPage);
    const page = fixPage === -1 ? state.taskItemsOption.page : fixPage;

    const tokens = state.taskItemsOption.keyword.split(" ");
    if (tokens.length >= 2) {
      const res = await iWorkspace.getWorkspaceItemIdList({
        taskId: state.info.taskId,
        fileNames: tokens.splice(0, 300),
        workType: state.info.workType,
      });

      if (res.data.code !== "") {
        return res.data.code;
      }

      state.taskItemsOption.taskItemIdList = res.data.payload;
    } else {
      state.taskItemsOption.keyword = tokens[0];
      state.taskItemsOption.taskItemIdList = [];
    }

    const payload = {
      ...getTaskItemsParams(),
      projectId: state.info.projectId,
      taskId: state.info.taskId,
      page,
    };
    const res = await iWorkspace.getWorkspaceItems(payload);
    const code = res?.data.code;
    if (code !== "") {
      return code;
    }

    commit("SET_TASKITEMS", { items: res.data.items });
    return code;
  },

  async setWorkspacePage({ state, commit }, fixPage = -1) {
    const result = {
      currentPage: 0,
      totalPage: 0,
      totalCount: 0,
    };

    const payload = {
      ...getTaskItemsParams(),
      taskItemId: state.taskItem.id,
      limit: 20,
    };

    const res = await iWorkspace.getWorkspacePageInfo(payload);
    const code = res?.data.code;
    if (code !== "") {
      console.log("[Error] getWorkspacePageInfo : ", code);
      return code;
    }

    const currentPage = fixPage === -1 ? res.data.currentPage : fixPage;
    result.currentPage = currentPage;
    result.totalPage = res.data.totalPage;
    result.totalCount = res.data.totalCount;
    commit("SET_WORKSPACE_PAGE_INFO", result);

    return "";
  },
  async _setNewTaskItem({ state, commit, dispatch }) {
    const taskItemPayload = {
      taskItemId: state.taskItem.id,
      workType: state.info.workType,
    };

    const res = await iWorkspace.getWorkspaceItemDetail(taskItemPayload);
    const code = res?.data.code;
    const payload = res.data?.payload;

    if (code !== "" || !payload) {
      console.log("[Error] _setNewTaskItem, getWorkspaceItemDetail : ", code);
      return code;
    }

    commit("SET_IMG_SIZE", {
      width: payload.file.width,
      height: payload.file.height,
    });

    const objects = payload.json.objects;
    commit("SET_OBJECTS", objects);
    commit("SET_TASKITEM_INFO", payload);
    await dispatch("_setTaskItemImage");

    const workspacePayload = {
      taskId: state.info.taskId,
      workType: state.info.workType,
    };
    await dispatch("setWorkspaceInfo", workspacePayload);
    await dispatch("setTaskItems");

    return code;
  },
  async _setTaskItemImage({ commit }) {
    const path = state.taskItem.filePath;
    return new Promise((res) => {
      util.toDataURL(path, (result) =>
        res(commit("UPDATE_TASKITEM_FILE", { file: result }))
      );
    });
  },
  async setTaskItemById({ commit, dispatch }, payload) {
    commit("UPDATE_TASKITEM_ID", { id: payload.taskItemId });
    const code = await dispatch("_setNewTaskItem");
    return code;
  },
  // -----------------------------------------------------------
  async updateObjects({ commit, state, dispatch }, data = {}) {
    commit("SET_WORKSPACE_SAVING", { saving: true });
    const objects = util.exportTaskResult(
      data.objects || state.objects,
      state.classes
    );
    const payload = {
      taskItemId: data.taskItemId || state.taskItem.id,
      workType: state.info.workType,
      objects,
    };
    const res = await iWorkspace.updateWorkItemData(payload);

    if (res.data.code === "TK0001") {
      commit("SET_WORKSPACE_SAVING", { saving: false });
      return res.data.code;
    }
    if (res.data.code === "TK0003") {
      commit("SET_WORKSPACE_SAVING", { saving: false });
      return res.data.code;
    }
    if (["W0002", "W0003"].includes(res.data.code)) {
      commit("SET_WORKSPACE_SAVING", { saving: false });
      return res.data.code;
    }

    if (res.data.code === "W0008" && !state.workloadSatisfied) {
      commit("SET_IS_WORKLOAD_SATISFIED", { workloadSatisfied: true });
    }

    if (res.data.changedStatus !== state.taskItem.itemStatus) {
      commit("SET_CURRENT_TASKITEM_STATUS", { status: res.data.changedStatus });
      dispatch("setProgress");
      await dispatch("setTaskItems");
    }
    commit("SET_WORKSPACE_SAVING", { saving: false });
    return res.data.code;
  },

  async executeComplete({ state, commit, dispatch }) {
    const payload = {
      taskItemId: state.taskItem.id,
      workType: state.info.workType,
      nextTaskItemId: state.page.nextTaskItemId,
    };

    const res = await iWorkspace.executeComplete(payload);
    if (res.data.code === "W0008" && !state.workloadSatisfied) {
      commit("SET_IS_WORKLOAD_SATISFIED", { workloadSatisfied: true });
      return res.data.code;
    }

    if (res.data.code === "TK0001") {
      return res.data.code;
    }

    if (res.data.code === "TK0003") {
      return res.data.code;
    }

    if (["W0002", "W0003"].includes(res.data.code)) {
      return res.data.code;
    }

    dispatch("setProgress");
    return res.data.code;
  },
  async executeReject({ state, commit, dispatch }) {
    const payload = {
      taskItemId: state.taskItem.id,
      workType: state.info.workType,
    };

    const res = await iWorkspace.executeReject(payload);
    if (res.data.code === "W0008" && !state.workloadSatisfied) {
      commit("SET_IS_WORKLOAD_SATISFIED", { workloadSatisfied: true });
    }
    dispatch("setProgress");
    return res.data.code;
  },
  async executeDelete({ state, commit, dispatch }) {
    const payload = {
      taskItemId: state.taskItem.id,
      workType: state.info.workType,
    };

    const res = await iWorkspace.executeDelete(payload);
    if (res.data.code === "W0008" && !state.workloadSatisfied) {
      commit("SET_IS_WORKLOAD_SATISFIED", { workloadSatisfied: true });
    }
    dispatch("setProgress");
    return res.data.code;
  },
  async postImgSize({ commit }, payload) {
    // 이미지 사이즈 포스팅 동작확인
    commit("SET_IMG_SIZE", { width: payload.width, height: payload.height });
    const res = await iWorkspace.postImgSize(payload);
    const code = res?.data.code;
    if (code !== "") {
      return code;
    }
    return res.data.code;
  },
  async delayTaskItem({ state }) {
    const payload = {
      taskId: state.info.taskId,
      workType: state.info.workType,
    };
    const res = await iWorkspace.delayTaskItem(payload);
    return res;
  },

  async priceChangeCheck({ state }) {
    const payload = {
      exposeLevel: "MID",
      taskId: state.info.taskId,
    };

    const contracts = await iPrice.getAbbreviatedContracts(payload);

    if (!contracts) {
      return;
    }

    const targetContract = contracts.data.payload.find(
      (item) => item.role === state.info.workType
    );

    switch (targetContract.status) {
      case "CONTRACT_ON_GOING":
      case "CONTRACT_OBSOLETE": {
        state.priceChange = true;
        return state.priceChange;
      }

      case "CONTRACT_IN_EFFECT":
      case "CONTRACT_FAILED": {
        state.priceChange = false;
        return state.priceChange;
      }
    }
  },
};

const getTaskItemsParams = () => ({
  workType: state.info.workType,
  keyword:
    state.taskItemsOption.taskItemIdList.length > 0
      ? ""
      : state.taskItemsOption.keyword,
  taskItemIdList: state.taskItemsOption.taskItemIdList,
  limit: state.taskItemsOption.limit,
  statuses: state.taskItemsOption.statuses.join(","),
  operatorIds: state.taskItemsOption.operatorIds.join(","),
});

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
